import {getAxios, User, Pageable, searchUsers} from '@deviceinsight/ng-ui-api-client';

const getUserByCustomerId = (id: string): Promise<User> =>
	getAxios()
		.get(`/v2/accounts?type=USERNAME&name=${id}`)
		.then((response) => response.data);

const fetchAllAccountGroupsOfUser = (): Promise<Pageable<User>> =>
	getAxios()
		.get(`/v2/accountGroups`)
		.then((response) => response.data);

const fetchUsersByAccountNr = (accountNrs: string[]): Promise<Array<User>> => {
	const searchString = accountNrs.length
		? `accountNumber: (${[...Array.from(new Set(accountNrs))].join(' OR ')})`
		: '';

	return searchUsers(searchString, {
		sort: {
			property: 'username',
			direction: 'ASC'
		},
		page: 0,
		size: 2000
	})
		.then((response) => {
			return response.content;
		})
		.catch((err) => {
			console.error(err);
			return [];
		});
};

export {getUserByCustomerId, fetchAllAccountGroupsOfUser, fetchUsersByAccountNr};
